import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    getUserInterests,
    getUserInterestsVariables,
} from "./__graphql-types__/getUserInterests.ts";

export const GUIDE_INTERESTS_QUERY: GqlOperation<
    getUserInterests,
    getUserInterestsVariables
> = gqlOp(gql`
    query getUserInterests($kaid: String!) {
        user(kaid: $kaid) {
            id
            isCollectingInterests
            aiGuideUserInterests {
                interest
                combinedKey
            }
        }
    }
`);
